exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#help-box{position:absolute;width:350px;height:100%;background-color:green;right:0;z-index:1}table.dataTable thead .no-sort:after{display:none!important}table.dataTable thead .no-sort{pointer-events:none!important;cursor:default!important}table.dataTable td,table.dataTable th{-webkit-box-sizing:border-box!important;box-sizing:border-box!important}.dataTables_wrapper{overflow-x:auto!important}.dataTables_wrapper .row{margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-66098b1c!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DataTable.vue
// module id = 826
// module chunks = 2